import React, { forwardRef, useState } from "react";
import { ReactComponent as SaveIcon } from "../../assets/icons/general/save.svg";
import SaveCartRecordModal from "./SaveCartRecordModal.jsx";

const SaveCartRecord = forwardRef(function SaveCartRecord(
  { cartNumber, relevantUrl, ...props }, // ← grab injected props from Tooltip
  ref
) {
  const [open, setOpen] = useState(false);


    // VIEW JIRA INSTRUCTIONS BEFORE CONTINUING WITH THIS FEATURE.
    /**
     * Implement a new button in the Site Manager UI that allows the operator to manually trigger the save_record_event(data) command on the cart.
When pressed, the button should send the event to the corresponding cart service, prompting it to save the current cyclical recording session (last 5 to 10 minutes).      

Button label: Save Record

data example:
{
  record_name: "hard_stop"
}
     * 
     */


  return (
    <>
      <span
        ref={ref}
        {...props}                        // ← pass Tooltip’s handlers to the DOM node
        style={{ cursor: "pointer", margin: 4 }}
        onClick={() => setOpen(true)}
        // optional: make it keyboard-focusable for a11y/focus tooltips
        tabIndex={0}
        onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && setOpen(true)}
      >
        <SaveIcon width={24} height={24} />
      </span>

      <SaveCartRecordModal
        open={open}
        onClose={() => setOpen(false)}
        cartNumber={cartNumber}
        relevantUrl={relevantUrl}
      />
    </>
  );
});

export default SaveCartRecord;
